import React from "react";
import { UserCategoriesFacadeProvider } from "./facades/UserCategories.facade";
import { UserCategoriesServiceProvider } from "./services/UserCategories.service";
import { UserCategoriesRoutes } from "./UserCategoriesRoutes";

export const UserCategories = () => {
  return (
    <>
      <UserCategoriesServiceProvider>
        <UserCategoriesFacadeProvider>
          <UserCategoriesRoutes></UserCategoriesRoutes>
        </UserCategoriesFacadeProvider>
      </UserCategoriesServiceProvider>
    </>
  );
};
